import { useState, useEffect, useRef } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./Dialog";
import { Button } from "./Button";
import { Input } from "./Input";
import { Label } from "./Label";
import { Textarea } from "./Textarea";

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "./Select";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { Popover, PopoverContent, PopoverTrigger } from "./Popover";
import { cn } from "../../utils/utils";
import { message } from "antd";
import axios from "../../axios/AxiosInstance";
import MultiSelect from "./MultiSelect";
import { DayPicker } from "react-day-picker";

function TaskModal({
  open,
  isUpdating,
  task,
  onOpenChange,
  updateOnCreate,
  takers,
}) {
  const [clientSearch, setClientSearch] = useState("");
  const [candidateSearch, setCandidateSearch] = useState("");
  const [clients, setClients] = useState([]);
  const [selectedClientsName, setSelectedClientsName] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const [showClientDropdown, setShowClientDropdown] = useState(false);
  const [showCandidateDropdown, setShowCandidateDropdown] = useState(false);
  const [isLoadingClient, setIsLoadingClient] = useState(false);
  const [isLoadingCandidate, setIsLoadingCandidate] = useState(false);
  const [timer, setTimer] = useState(null);

  /*   const searchClient = (query) => {
    setClientSearch(query);
    const results = clients.filter((client) =>
      client.name.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredClients(results);
    setShowClientDropdown(true);
  }; */

  const searchClient = (word) => {
    console.log(word);

    setClientSearch(word);
    if (word.length === 0) {
      setClients([]);
    }
    if (word.length < 3) {
      if (timer) clearTimeout(timer);
    }
    if (word.length >= 3) {
      if (timer) clearTimeout(timer);

      const timer2 = setTimeout(() => {
        setIsLoadingClient(true);
        axios
          .post("client/freelance/find-by-text", { query: word })
          .then((res) => {
            setClients(res.data);
            setShowClientDropdown(true);
            console.log(res.data);
          })
          .catch((e) => console.log(e))
          .finally(() => setIsLoadingClient(false));
      }, 700);
      setTimer(timer2);
    }
  };

  const searchCandidate = (word) => {
    console.log(word);

    setCandidateSearch(word);
    if (word.length === 0) {
      setCandidates([]);
    }
    if (word.length < 3) {
      if (timer) clearTimeout(timer);
    }
    if (word.length >= 3) {
      if (timer) clearTimeout(timer);

      const timer2 = setTimeout(() => {
        setIsLoadingCandidate(true);
        axios
          .post("tempworker-candidate/freelance/find-by-text", { query: word })
          .then((res) => {
            setCandidates(res.data);
            setShowCandidateDropdown(true);
            console.log(res.data);
          })
          .catch((e) => console.log(e))
          .finally(() => setIsLoadingCandidate(false));
      }, 700);
      setTimer(timer2);
    }
  };
  const clientRef = useRef(null);
  const candidateRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        candidateRef.current &&
        !candidateRef.current.contains(event.target)
      ) {
        setShowCandidateDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (clientRef.current && !clientRef.current.contains(event.target)) {
        setShowClientDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const userId = localStorage.getItem("userId");
  // Initial form state
  const [formData, setFormData] = useState({
    type: "",
    priority: "",
    date: undefined,
    hour: "",
    comment: "",
    clients: [],
    candidates: [],
    taskManager: "",
    taskManagers: [],
  });

  // Reset form when modal opens
  useEffect(() => {
    if (open) {
      if (isUpdating) {
        setFormData({
          type: task.type,
          priority: task.priority,
          date: new Date(task.date),
          hour: task.hour,
          comment: task.comment,
          clients: task.clients,
          candidate: task.candidate,
          taskManager: task.manager,
        });
      }
    }
  }, [open]);

  /*  const createTask = () => {
   
    const data = {}
    data.taskCreator = userId
    data.type = taskType
    data.date = date
    data.comment = comment
    data.taskManager = taker
   
    if (selectedClient) data.client = selectedClient._id
    if (selectedCandidate) data.candidate = selectedCandidate._id
    axiosInstance
      .post('task', data)
      .then((res) => {
        const newTasks = [res.data, ...tasks]
        setTasks(newTasks)
        message.success('Tâche créée ! ')
        resetTaskFields()
        setIsOpenCreateTask(false)
      })
      .catch((e) =>{
        console.log(e); 
        message.error("Une erreur s'est produite ! ")
        })
  } */

  // Sample data (in real app, this would come from an API or props)
  const taskTypes = [
    { id: "5", name: "Administratif" },
    { id: "578963", name: "Appel" },
    { id: "5469", name: "Autre" },
    { id: "1", name: "Entretien" },
    { id: "54788", name: "Information" },

    { id: "78932", name: "Prospection" },
    { id: "4", name: "Recrutement" },
    { id: "3", name: "Relance" },

    { id: "2", name: "Suivi" },

    { id: "7893244", name: "Visite client" },
  ];

  const priority = [
    { id: "1", name: "Urgent" },
    { id: "2", name: "Haute" },
    { id: "3", name: "Moyenne" },
    { id: "4", name: "Basse" },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isFormComplete() && selectedUsers.length > 0) {
      // Do your POST
      formData.taskCreator = userId;
      console.log(formData);
      console.log(selectedUsers);
      createTask();
      console.log("Form is complete, posting...");
      onOpenChange(false);
    } else {
      console.log("Please fill all fields before submitting.");
    }
  };

  const createTask = () => {
    const sentData = { ...formData };
    sentData.clients = sentData.clients.map((client) => client._id);
    sentData.candidates = sentData.candidates.map((candidate) => candidate._id);
    sentData.taskManagers = selectedUsers;
    axios
      .post("newtask", sentData)
      .then((res) => {
        console.log(res.data);
        updateOnCreate(res.data);
        setSelectedUsers([]);
        message.success("Tâche créée ! ");
      })
      .catch((e) => {
        console.log(e);
        message.error("Une erreur s'est produite ! ");
      });
  };

  const isFormComplete = () => {
    const { type, priority, date, hour } = formData;
    console.log(type);
    console.log(priority);
    console.log(date);
    console.log(hour);
    return type !== "" && priority !== "" && date !== undefined && hour !== "";
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[550px] p-0 overflow-hidden bg-white rounded-xl">
        <div className="bg-gradient-to-r from-indigo-500 to-indigo-600 py-4 px-6">
          <DialogTitle className="text-xl font-semibold text-white mb-1">
            Nouvelle tâche
          </DialogTitle>
          <DialogDescription className="text-indigo-100">
            Créez une nouvelle tâche à suivre ou à assigner
          </DialogDescription>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4 p-6 bg-white">
          <div className="grid grid-cols-1 gap-y-4 bg-white">
            {/* Task Type */}
            <div className="space-y-2">
              <Label
                htmlFor="taskType"
                className="text-sm font-medium text-gray-700"
              >
                Type de tâche
              </Label>
              <Select
                value={formData.type}
                onValueChange={(value) =>
                  setFormData({ ...formData, type: value })
                }
                className="bg-white text-black"
              >
                <SelectTrigger className="w-full border bg-white border-gray-300 rounded-md text-black">
                  <SelectValue placeholder="Sélectionner le type de tâche" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectLabel className="bg-white">
                      Types de tâches
                    </SelectLabel>
                    {taskTypes.map((type) => (
                      <SelectItem
                        className="bg-white text-black"
                        key={type.id}
                        value={type.name}
                      >
                        {type.name}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-2">
              <Label
                htmlFor="taskType"
                className="text-sm font-medium text-gray-700"
              >
                Priorité de la tâche
              </Label>
              <Select
                value={formData.priority}
                onValueChange={(value) =>
                  setFormData({ ...formData, priority: value })
                }
                className="bg-white"
              >
                <SelectTrigger className="w-full border bg-white border-gray-300 rounded-md text-black">
                  <SelectValue placeholder="Sélectionner le type de priorité" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectLabel className="bg-white">Priorité</SelectLabel>
                    {priority.map((prior) => (
                      <SelectItem
                        className="bg-white"
                        key={prior.id}
                        value={prior.name}
                      >
                        {prior.name}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
            </div>

            {/* Date and Time in a 2-column layout */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {/* Date Picker */}
              <div className="space-y-2">
                <Label
                  htmlFor="date"
                  className="text-sm font-medium text-gray-700"
                >
                  Date de la tâche
                </Label>
                <Popover>
                  <PopoverTrigger asChild>
                    <Button
                      variant="outline"
                      className={cn(
                        "w-full justify-start text-left font-normal border border-gray-300 rounded-md",
                        !formData.date && "text-gray-400",
                      )}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="mr-2 h-4 w-4 text-gray-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                        />
                      </svg>
                      {formData.date ? (
                        format(formData.date, "dd/MM/yyyy", { locale: fr })
                      ) : (
                        <span className="text-black">
                          Sélectionner une date
                        </span>
                      )}
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent className="w-auto p-0 bg-white" align="start">
                    <DayPicker
                      showOutsideDays="true"
                      className="p-8"
                      mode="single"
                      classNames={{
                        day: "w-8 h-8 border border-gray-100 rounded-md ml-2",
                      }}
                      locale={fr}
                      selected={formData.date}
                      onSelect={(date) => {
                        const newDate = new Date(date);
                        newDate.setHours(12);
                        setFormData({ ...formData, date: newDate });
                        console.log(newDate);
                      }}
                    />
                  </PopoverContent>
                </Popover>
              </div>

              {/* Time Picker */}
              <div className="space-y-2">
                <Label
                  htmlFor="time"
                  className="text-sm font-medium text-gray-700"
                >
                  Heure de la tâche
                </Label>
                <div className="relative text-gray-400">
                  <Input
                    id="time"
                    type="time"
                    value={formData.hour}
                    onChange={(e) =>
                      setFormData({ ...formData, hour: e.target.value })
                    }
                    className="w-full border border-gray-300 rounded-md pl-10"
                  />
                </div>
              </div>
            </div>

            {/* Comment */}
            <div className="space-y-2">
              <Label
                htmlFor="comment"
                className="text-sm font-medium text-gray-700"
              >
                Commentaire
              </Label>
              <Textarea
                id="comment"
                value={formData.comment}
                onChange={(e) =>
                  setFormData({ ...formData, comment: e.target.value })
                }
                placeholder="Détails de la tâche..."
                className="min-h-[100px] border border-gray-300 rounded-md"
              />
            </div>

            {/* Client */}
            <div ref={clientRef} className="space-y-2">
              <Label
                htmlFor="client"
                className="text-sm font-medium text-gray-700"
              >
                Client(s) concerné(s)
              </Label>
              <div className="relative">
                <Input
                  value={clientSearch}
                  onChange={(e) => searchClient(e.target.value)}
                  placeholder="Rechercher le client"
                  className="w-full border border-gray-300 rounded-md pr-10"
                />
                {isLoadingClient && (
                  <div className="absolute inset-y-0 right-3 flex items-center">
                    <svg
                      className="animate-spin h-4 w-4 text-gray-500"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8H4z"
                      ></path>
                    </svg>
                  </div>
                )}
              </div>

              {showClientDropdown && clients.length > 0 && (
                <ul className=" z-10 mt-1 w-11/12 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-auto">
                  {clients.map((client) => (
                    <li
                      key={client._id}
                      onClick={() => {
                        console.log(formData);

                        const alreadySelected = formData.clients?.some(
                          (c) => c._id === client._id,
                        );

                        const updatedClients = alreadySelected
                          ? formData.clients.filter((c) => c._id !== client._id)
                          : [
                              ...formData.clients,
                              { _id: client._id, name: client.companyName },
                            ];

                        setFormData({ ...formData, clients: updatedClients });
                      }}
                      className={`px-4 py-2 cursor-pointer hover:bg-gray-100 ${
                        formData.clients?.some((c) => c._id === client._id)
                          ? "bg-indigo-100 font-semibold"
                          : ""
                      }`}
                    >
                      {client.companyName}
                    </li>
                  ))}
                </ul>
              )}
              {formData.clients.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-2">
                  {formData.clients.map((client) => (
                    <span
                      key={client._id}
                      className="flex items-center bg-indigo-100 text-indigo-800 text-sm font-medium px-3 py-1 rounded-full"
                    >
                      {client.name}
                      <button
                        type="button"
                        onClick={() => {
                          const updatedClients = formData.clients.filter(
                            (c) => c._id !== client._id,
                          );
                          setFormData({ ...formData, clients: updatedClients });
                        }}
                        className="ml-2 text-indigo-500 hover:text-indigo-700 focus:outline-none"
                      >
                        &times;
                      </button>
                    </span>
                  ))}
                </div>
              )}
            </div>

            <div ref={candidateRef} className="space-y-2">
              <Label
                htmlFor="client"
                className="text-sm font-medium text-gray-700"
              >
                Candidat(s) concerné(s)
              </Label>
              <div className="relative">
                <Input
                  value={candidateSearch}
                  onChange={(e) => searchCandidate(e.target.value)}
                  placeholder="Rechercher un candidat"
                  className="w-full border border-gray-300 rounded-md pr-10"
                />
                {isLoadingCandidate && (
                  <div className="absolute inset-y-0 right-3 flex items-center">
                    <svg
                      className="animate-spin h-4 w-4 text-gray-500"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8H4z"
                      ></path>
                    </svg>
                  </div>
                )}
              </div>

              {showCandidateDropdown && candidates.length > 0 && (
                <ul className=" z-10 mt-1 w-11/12 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-auto">
                  {candidates.map((candidate) => (
                    <li
                      key={candidate._id}
                      onClick={() => {
                        console.log(formData);

                        const alreadySelected = formData.candidates?.some(
                          (c) => c._id === candidate._id,
                        );

                        const updatedCandidates = alreadySelected
                          ? formData.candidates.filter(
                              (c) => c._id !== candidate._id,
                            )
                          : [
                              ...formData.candidates,
                              {
                                _id: candidate._id,
                                name:
                                  candidate.firstname +
                                  " " +
                                  candidate.lastname,
                              },
                            ];

                        setFormData({
                          ...formData,
                          candidates: updatedCandidates,
                        });
                      }}
                      className={`px-4 py-2 cursor-pointer hover:bg-gray-100 ${
                        formData.candidates?.some(
                          (c) => c._id === candidate._id,
                        )
                          ? "bg-indigo-100 font-semibold"
                          : ""
                      }`}
                    >
                      {candidate.firstname} {candidate.lastname} -{" "}
                      <span className="italic">{candidate.phone}</span>
                    </li>
                  ))}
                </ul>
              )}
              {formData.candidates?.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-2">
                  {formData.candidates.map((candidate) => (
                    <span
                      key={candidate._id}
                      className="flex items-center bg-indigo-100 text-indigo-800 text-sm font-medium px-3 py-1 rounded-full"
                    >
                      {candidate.name}
                      <button
                        type="button"
                        onClick={() => {
                          const updatedCandidates = formData.candidates.filter(
                            (c) => c._id !== candidate._id,
                          );
                          setFormData({
                            ...formData,
                            candidates: updatedCandidates,
                          });
                        }}
                        className="ml-2 text-indigo-500 hover:text-indigo-700 focus:outline-none"
                      >
                        &times;
                      </button>
                    </span>
                  ))}
                </div>
              )}
            </div>

            {/* Assigned To */}
            <div className="space-y-2">
              <Label
                htmlFor="taskManager"
                className="text-sm font-medium text-gray-700"
              >
                Attribuée à
              </Label>
              <MultiSelect
                options={takers.map((user) => ({
                  label: user.label,
                  value: user.value,
                }))}
                selected={selectedUsers}
                setSelected={setSelectedUsers}
              />
              {/*  <Select
                value={formData.taskManager}
                onValueChange={(value) => {
                  setFormData({ ...formData, taskManager: value })
                  console.log(value)
                  console.log(formData)
                }}
              >
                <SelectTrigger className="w-full border border-gray-300 rounded-md text-black">
                  <SelectValue placeholder="Attribuer à un (ou plusieurs) utilisateur(s)" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectLabel className="bg-white">Utilisateurs</SelectLabel>
                    {takers.map((user) => (
                      <SelectItem
                        className="bg-white"
                        key={user._id}
                        value={user.value}
                      >
                        {user.label}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select> */}
            </div>
          </div>

          <DialogFooter className="flex justify-end mt-6 pt-4 border-t border-gray-100">
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
              className="mr-2 border-gray-300"
            >
              Annuler
            </Button>
            <Button
              type="submit"
              className="bg-indigo-600 mb-20 hover:bg-indigo-700 text-white font-medium"
            >
              {!isUpdating && <span>Créer la tâche</span>}
              {isUpdating && <span>Mettre à jour la tâche</span>}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
export default TaskModal;
